import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

interface ErrorPageProps {
  code: string;
  title: string;
  description: string;
}

export function ErrorPage({ code, title, description }: ErrorPageProps) {
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        display: "grid",
        minHeight: "100dvh",
        placeItems: "center",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <Paper
        variant="outlined"
        sx={{ width: "100%", maxWidth: 560, p: { xs: 3, sm: 5 } }}
      >
        <Stack spacing={2.5} sx={{ alignItems: "center", textAlign: "center" }}>
          <Typography
            color="primary.main"
            component="p"
            variant="h3"
            sx={{ fontWeight: 800 }}
          >
            {code}
          </Typography>
          <Typography component="h1" variant="h4" sx={{ fontWeight: 750 }}>
            {title}
          </Typography>
          <Typography color="text.secondary">{description}</Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ pt: 1, width: { xs: "100%", sm: "auto" } }}
          >
            <Button onClick={() => navigate("/dashboard")} variant="contained">
              Go back home
            </Button>
            <Button
              component="a"
              href="mailto:support@badmintonwarriors.com"
              variant="outlined"
            >
              Contact us
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
